import { adminApi, devlopConfigAPi } from "src/api";

const casesTemplate=()=>{
    return adminApi.get(`Case/TemplateLu`)
}

const assignAdmins=()=>{
    return adminApi.get(`Case/AdminUsers`)
}

const adminData=(id,screenName)=>{
    return adminApi.get(`CaseManagement/Cases/${id}/${screenName}`)
}
const createCase=(obj,method)=>{
    if(method !='update')
      return devlopConfigAPi.post(`CaseManagement/Cases/Case`,obj)
    else{
        return devlopConfigAPi.put(`CaseManagement/Cases/Case`,obj)
    }
}

const apicallsForCases ={casesTemplate,assignAdmins,adminData,createCase}

export default apicallsForCases